<template>
    <div class="card">
        <v-server-table
            class="dashboard"
            url="/dtable/repairstats"
            :columns="columns"
            :options="options"
        >
            <template slot="beforeFilter">
                <h4 class="card-title">
                    {{ $t("dashboard.repairs_title") }}
                    <p class="card-category text-muted">{{ $t("dashboard.repairs_subtitle") }}</p>
                </h4>
            </template>
            <template slot="child_row" scope="props">
              <div><b>Teste 1:</b> {{props.row.repair_parts}}</div>
              <div><b>Teste 2:</b> {{props.row.repair_used_parts}}</div>
            </template>
            <template slot="child_row" scope="props">
              <div><b>Teste 1:</b> {{props.row.repair_parts}}</div>
              <div><b>Teste 2:</b> {{props.row.repair_used_parts}}</div>
            </template>
        </v-server-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        // "id",
        // "name",
        // "repairs_count",
        // "repairs_finished",
        // "parts_used",
        // "parts_inwarranty",
        // "parts_bought",
        // "parts_all"
        'repair_id',
        'model_name',
        'repair_parts',
        'repair_used_parts',
        'accessories',
        'created_at'
      ],
      options: {
        perPage: 15,
        perPageValues: [],
        // headings: {
        //   id: "Id",
        //   name: this.$t('field.asf'),
        //   repairs_count: "Reparos Totais",
        //   repairs_finished: "Reparos Finalizados",
        //   parts_used: "Peças Utilizadas",
        //   parts_inwarranty: "Peças em Garantia",
        //   parts_bought: "Peças Compradas",
        //   parts_all: "Peças Totais",
        // },
        texts: {
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
        },
        orderBy: {
          ascending: true,
          column: "repair_id"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-xs table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"]
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {

        const tHeader = ['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = ['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.tableData;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
